
const convertHexColorToHSL = (hex) => {
    try {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        let r = parseInt(result[1], 16);
        let g = parseInt(result[2], 16);
        let b = parseInt(result[3], 16);
        r /= 255;
        g /= 255;
        b /= 255;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);

        let hue = 0;
        let saturation = 0;
        const lightness = (max + min) / 2;
        if (max === min) {
            hue = saturation = 0; // achromatic
        } else {
            const delta = max - min;
            saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
            switch (max) {
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        return {
            h: Math.round(hue * 360),
            s: Math.round(saturation * 100),
            l: Math.round(lightness * 100)
        };
    } catch (e) {
        console.error(`Problem parsing hex ${hex}!  Using #000000 as fallback.`);
        return {
            h: Math.round(0),
            s: Math.round(0),
            l: Math.round(0)
        };
    }
};

const setColorsInDom = ({ primaryColor, secondaryColor }) => {
    const primary = convertHexColorToHSL(primaryColor);
    const secondary = convertHexColorToHSL(secondaryColor);

    const css = `:root {
        --color-primary: hsl(${primary.h}, ${primary.s}%, ${primary.l}%);
        --color-primary-h: ${primary.h};
        --color-primary-s: ${primary.s}%;
        --color-primary-l: ${primary.l}%;
        --color-secondary: hsl(${secondary.h}, ${secondary.s}%, ${secondary.l}%);
        --color-secondary-h: ${secondary.h};
        --color-secondary-s: ${secondary.s}%;
        --color-secondary-l: ${secondary.l}%;
    }`;

    const styleElement = document.getElementById('dialogue-theme-colors');
    if ( styleElement ) {
        styleElement.innerHTML = css;
    } else {
        const style = document.createElement('style');
        style.appendChild(document.createTextNode(css));
    }
};

const isColorInHexFormat = (color) => {
  const isHexRegEx = /^#([0-9a-f]{3}){1,2}$/i;
  return isHexRegEx.test(color);
};

export {
    convertHexColorToHSL,
    setColorsInDom,
    isColorInHexFormat
};
